import { Box, Button, styled } from "@/components";

const StyledBox = styled(Box)(({ theme, asking = "false" }) => {
  const isAsking = Boolean(asking.replace(/false/, ""));

  return {
    marginRight: theme.spacing(isAsking ? 0 : 4),
    marginLeft: theme.spacing(isAsking ? 4 : 0),
    "& > div": {
      justifyContent: isAsking ? "flex-end" : "flex-start",
      "& > div": {
        minHeight: 44,
        display: "flex",
        alignItems: "center",
        position: "relative",
        backgroundColor: theme.palette[isAsking ? "primary" : "gray2"].main,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0.8, 2),
        color: theme.palette[isAsking ? "primary" : "gray2"].contrastText,
        "& code": {
          padding: theme.spacing(0, 1),
          borderRadius: theme.shape.borderRadius / 2,
          backgroundColor: "#ffffff8a",
          color: theme.palette.gray1.contrastText,
        },
      },
    },
  };
});

const StyledIntent = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.shape.borderRadius,
}));

export { StyledBox, StyledIntent };
